'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//

var prefixCls = 'icon';
exports.default = {
  name: 'Icon',
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes: function classes() {
      return prefixCls + '-' + this.type;
    }
  },
  methods: {
    handleClick: function handleClick(event) {
      this.$emit('click', event);
    }
  }
};